import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import BlackProfile from "@img/icons/blankProfile.png";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import { ChildType } from "@store/SchedulePermission";
import { useHistory } from "react-router-dom";
import {
  AiFillExclamationCircle,
  AiFillInfoCircle,
  AiFillCloseCircle,
  AiFillCheckCircle,
} from "react-icons/ai";
import ClickAwayListener from "react-click-away-listener";
import { useWidth } from "@utils/demenstion";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import { AlertConfrim, AlertSuccess } from "@utils/alert";
import dayjs from "dayjs";

interface CardChildProps {
  item: ChildType;
  getStudentsData: (pageNumber: number) => void;
  index?: number;
}

const CardChild = observer(
  ({ item, getStudentsData, index }: CardChildProps) => {
    const history = useHistory();
    const { landing, renewal } = useMst();
    const [popup, setPopup] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [nextAcademicYear, setNextAcademicYear] = useState(0);
    const [checkRenewalChild, setCheckRenewalChild] =
      useState<RenewalCheckType | null>(null);

    useEffect(() => {
      if (landing.token) {
        renewal.getCheckRenewalChild(
          landing.token,
          item,
          (data: RenewalCheckType) => {
            setCheckRenewalChild(data);
          }
        );
      }
    }, [item]);

    const options = useMemo(
      () => (item.isMain ? ["Schedule Permission", "Edit"] : ["Edit"]),
      [item.isMain]
    );

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (option?: string) => {
      if (option === "Schedule Permission") {
        history.push(`/dashboard/manage/child/schedule_permission/${item.id}`);
      } else if (option === "Edit") {
        history.push(`/dashboard/manage/child/edit/${item.id}`);
      }
      setAnchorEl(null);
    };

    const renewScheduleChild = useCallback(() => {
      if (landing.token && checkRenewalChild?.nextAcademicYear.id) {
        renewal.putRenewalScheduleChild(
          landing.token,
          item.id,
          true,
          checkRenewalChild.nextAcademicYear.id,
          () => {
            AlertSuccess(
              "Renewal Success",
              checkRenewalChild?.nextAcademicYear?.schoolId === 8
                ? "If there are any changes to your child's transportation needs (change of residential or billing address, journey, consent drop-off for CP & CE1 students, etc) please email to Transport Office at ifs@woodlandstransport.com.sg or to the respective school Transport Office) as soon as possible for processing."
                : "If there are any changes to your child's transportation needs (Address, Schedule, etc.), please contact us as soon as possible so that we can make the necessary adjustments."
            );
            getStudentsData(1);
          }
        );
      }
    }, [landing.token, item, checkRenewalChild]);

    const terminateScheduleChild = useCallback(() => {
      if (landing.token && checkRenewalChild?.nextAcademicYear.id) {
        renewal.putRenewalScheduleChild(
          landing.token,
          item.id,
          false,
          checkRenewalChild.nextAcademicYear.id,
          () => {
            AlertSuccess("Success", "Decline Success");
            getStudentsData(1);
          }
        );
      }
    }, [landing.token, item, checkRenewalChild]);

    const isRenewalConfrim = useMemo(
      () => checkRenewalChild?.status === "pending",
      [checkRenewalChild?.status]
    );

    const RenewalStatusTitle = useCallback(() => {
      if (isRenewalConfrim) {
        return (
          <p className="text-black font-bold text-2xl">
            {`Your child is due for Renewal on ${dayjs(
              checkRenewalChild?.nextAcademicYear.earlyRegistrationEndDate
            ).format("DD MMM YYYY")}`}
          </p>
        );
      }
      if (checkRenewalChild?.status === "declined") {
        return (
          <p className="text-black font-bold text-2xl">
            Child Renewal Response: Decline
          </p>
        );
      }
      if (checkRenewalChild?.status === "accepted") {
        return (
          <p className="text-black font-bold text-2xl">
            Child Renewal Response: Renew Next Academic Year
          </p>
        );
      }
    }, [checkRenewalChild, isRenewalConfrim]);

    const RenewalStatusDescription = useCallback(() => {
      if (isRenewalConfrim) {
        return (
          <>
            <p className="text-black font-bold text-xl">
              {`Do you want to renew the service for the next academic year?. Next academic year will start on ${dayjs(
                checkRenewalChild?.nextAcademicYear.startDate
              ).format("DD MMM YYYY")}`}
            </p>
            <p className="text-lg ">
              If you want to change schedule please contact admin
            </p>
          </>
        );
      }
      if (checkRenewalChild?.status === "declined") {
        return (
          <p className="text-black font-bold text-xl">
            Your child’s bus service will be terminated automatically
          </p>
        );
      }
      if (checkRenewalChild?.status === "accepted") {
        return (
          <p className="text-black font-bold text-xl">
            {`Your child’s bus service will be renewed automatically next academic
          year, ${dayjs(checkRenewalChild.nextAcademicYear.startDate).format(
            "DD MMM YYYY"
          )}`}
          </p>
        );
      }
    }, [checkRenewalChild, isRenewalConfrim]);

    return (
      <div className="relative bg-slate-200 mb-4 rounded-lg">
        <div className="bg-light_gray rounded-lg px-8 pt-8">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row space-x-8">
              <div className="w-28 h-28 min-w-[65px]">
                <img
                  src={item.photoUrl || BlackProfile}
                  className="rounded-full"
                />
              </div>
              <div className="flex flex-col space-y-1">
                <h1 className="text-bahama_blue_hover font-bold text-3xl">
                  {`${item.firstName} ${item.lastName}`}
                </h1>
                <StatusRender
                  checkRenewalChild={checkRenewalChild}
                  item={item}
                ></StatusRender>
              </div>
            </div>
            {useWidth() > 768 ? (
              <div className={`flex justify-end`}>
                <div className="grid justify-childs-end">
                  {item.isMain ? (
                    <>
                      <a
                        className="cursor-pointer text-bahama_blue_hover text-right font-bold underline"
                        onClick={() => {
                          history.push(
                            `/dashboard/manage/child/schedule_permission/${item.id}`
                          );
                        }}
                      >
                        Schedule Permission
                      </a>
                      <a
                        id={`edit-child-${index}`}
                        className="cursor-pointer text-bahama_blue_hover text-right font-bold underline"
                        onClick={() => {
                          history.push(
                            `/dashboard/manage/child/edit/${item.id}`
                          );
                        }}
                      >
                        Edit
                      </a>
                    </>
                  ) : null}
                </div>
              </div>
            ) : (
              <div>
                <IconButton
                  style={{ left: 10 }}
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon style={{ width: 26, height: 26 }} />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => handleClose()}
                  PaperProps={{
                    style: {
                      maxHeight: 48 * 4.5,
                      width: "300px",
                    },
                  }}
                >
                  {options.map((option) => (
                    <MenuItem
                      key={option}
                      selected={option === "Pyxis"}
                      onClick={(event) => {
                        handleClose(option);
                      }}
                      style={{
                        fontSize: 18,
                        color: "#234ea6",
                        fontWeight: "bold",
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            )}
          </div>
        </div>
        {checkRenewalChild ? (
          <div
            className={`bg-light_gray_secondary ml-10 py-8 pr-8 flex rounded-b-xl ${
              isRenewalConfrim ? "md:flex-row flex-col" : "flex-row"
            } justify-between md:space-x-10`}
          >
            <div className="md:w-2/3 w-full">
              {RenewalStatusTitle()}
              {RenewalStatusDescription()}
            </div>
            {isRenewalConfrim ? (
              <div className="flex flex-row space-x-4 childs-center md:w-1/3 w-full md:mt-0 mt-7 items-center">
                <div className="flex items-center">
                  {popup && (
                    <ClickAwayListener onClickAway={() => setPopup(false)}>
                      <div
                        className={
                          "absolute z-10 bg-white bottom-24 right-28 p-8 rounded-lg w-3/6"
                        }
                      >
                        <h1 className="font-bold text-2xl">Renew</h1>
                        <p className="text-xl">
                          Your child’s bus services will continue next academic
                          year
                        </p>
                        <h1 className="font-bold text-2xl">Decline</h1>
                        <p className="text-xl">
                          Your child’s bus services will be terminated by the
                          end of current academic year
                        </p>
                      </div>
                    </ClickAwayListener>
                  )}
                  <AiFillInfoCircle
                    onMouseEnter={() => setPopup(true)}
                    onMouseLeave={() => setPopup(false)}
                    className="text-4xl cursor-pointer"
                  ></AiFillInfoCircle>
                </div>
                <div className="flex flex-row w-full space-x-4 h-20 items-center">
                  <ButtonLoader
                    className="!bg-bt_green w-100"
                    onClick={() => {
                      AlertConfrim(
                        "Renew",
                        "Are you sure you want to renewal this item?",
                        async () => {
                          renewScheduleChild();
                        },
                        "Please wait",
                        "Please wait while we are renewing your child"
                      );
                    }}
                  >
                    Renew
                  </ButtonLoader>
                  <ButtonLoader
                    className=" !bg-bt_orange w-100"
                    onClick={() => {
                      AlertConfrim(
                        " Decline",
                        "Are you sure you want to Decline this item?",
                        async () => {
                          terminateScheduleChild();
                        },
                        "Decline Successfully",
                        "Child has been Decline"
                      );
                    }}
                  >
                    Decline
                  </ButtonLoader>
                </div>
              </div>
            ) : null}
            {checkRenewalChild.status === "accepted" ? (
              <div className="flex childs-center">
                <AiFillCheckCircle className="text-5xl text-green-500"></AiFillCheckCircle>
              </div>
            ) : null}
            {checkRenewalChild.status === "declined" ? (
              <div className="flex childs-center">
                <AiFillCloseCircle className="text-5xl text-red-500"></AiFillCloseCircle>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
);

const StatusRender = memo(
  ({
    checkRenewalChild,
    item,
  }: {
    checkRenewalChild: RenewalCheckType | null;
    item: ChildType;
  }) => {
    return (
      <h1 className="flex flex-row space-x-2">
        <h1
          className={`${
            item.status === "active" ? "text-green-500" : "text-red-500"
          } font-bold text-xl`}
        >
          {item.status === "active" ? "Active" : "Inactive"}
        </h1>
        {checkRenewalChild?.status === "pending" ? <h1>-</h1> : null}
        {checkRenewalChild?.status === "pending" ? (
          <p className="text-black font-bold text-xl">
            Renewal Confirmation Needed
          </p>
        ) : null}
        {checkRenewalChild?.status === "pending" ? (
          <AiFillExclamationCircle className="text-orange-500 text-2xl font-normal"></AiFillExclamationCircle>
        ) : null}
      </h1>
    );
  }
);

export default CardChild;
